import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import { Trash2 } from "lucide-react";
import { Api } from "../Api/Api";

export default function Wholesale() {
  const [form, setForm] = useState({
    category: "",
    product: "",
    barcode: "",
    stock: "",
    price: "",
    retail_price: "",
    image: "",
  });
  const [products, setProducts] = useState([]);
  const [editId, setEditId] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("All Products");

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await axios.get(`${Api}product/read.php`);
      setProducts(Array.isArray(res.data) ? res.data : []);
      console.log(res.data);
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setForm((prev) => ({ ...prev, image: reader.result }));
    };
    reader.readAsDataURL(file);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if ((name === "stock" || name === "price") && Number(value) < 1) {
      setForm({ ...form, [name]: "" });
      return;
    }

    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async () => {
    if (
      !form.category ||
      !form.product ||
      !form.barcode ||
      !form.stock ||
      !form.price ||
      !form.retail_price || // ✅ NEW FIELD
      !form.image
    ) {
      Swal.fire("Warning", "Please fill all required fields", "warning");
      return;
    }

    try {
      if (editId) {
        await axios.put(`${Api}product/mainupdate.php?id=${editId}`, form);
        Swal.fire("Updated!", "Product updated successfully", "success");
      } else {
        await axios.post(`${Api}product/create.php`, form);
        Swal.fire("Added!", "Product added successfully", "success");
      }
      fetchProducts();
      setForm({
        category: "",
        product: "",
        barcode: "",
        stock: "",
        price: "",
        retail_price: "", // ✅ NEW FIELD
        image: "",
      });
      setEditId(null);
    } catch (err) {
      console.error("Submit error", err);
      Swal.fire("Error", "Failed to save product", "error");
    }
  };

  // const handleDelete = async (id) => {
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "This will permanently delete the product.",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#d33",
  //     cancelButtonColor: "#6c757d",
  //     confirmButtonText: "Yes, delete it!",
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       try {
  //         await axios.get(`${Api}product/delete.php?id=${id}`);
  //         fetchProducts();
  //         Swal.fire("Deleted!", "Product has been deleted.", "success");
  //       } catch (err) {
  //         console.error("Delete error", err);
  //         Swal.fire("Error", "Failed to delete product", "error");
  //       }
  //     }
  //   });
  // };

  // const handleDeleteCategory = async (category) => {
  //   Swal.fire({
  //     title: `Delete "${category}"?`,
  //     text: "This will delete all products in this category. This action cannot be undone.",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#d33",
  //     cancelButtonColor: "#6c757d",
  //     confirmButtonText: "Yes, delete all",
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       try {
  //         await axios.get(
  //           `${Api}product/delete_category.php?category=${encodeURIComponent(
  //             category
  //           )}`
  //         );

  //         // ✅ Reset to All Products so it shows something instead of empty
  //         setSelectedCategory("All Products");

  //         fetchProducts();
  //         Swal.fire(
  //           "Deleted!",
  //           `All products in "${category}" were deleted.`,
  //           "success"
  //         );
  //       } catch (err) {
  //         console.error("Category delete error", err);
  //         Swal.fire("Error", "Failed to delete category", "error");
  //       }
  //     }
  //   });
  // };

  const handleDelete = async (id) => {
    // Step 1: Confirm delete intent
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "This will permanently delete the product.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, continue",
    });

    if (!confirmResult.isConfirmed) return;

    // Step 2: Ask for admin credentials
    const { value: credentials } = await Swal.fire({
      title: "Admin Verification Required",
      html: `
      <input type="text" id="swal-username" class="swal2-input" placeholder="Admin Username" />
      <input type="password" id="swal-password" class="swal2-input" placeholder="Admin Password" />
    `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Verify & Delete",
      preConfirm: () => {
        const username = document.getElementById("swal-username").value;
        const password = document.getElementById("swal-password").value;

        if (!username || !password) {
          Swal.showValidationMessage("Please enter both username and password");
          return false;
        }
        return { username, password };
      },
    });

    if (!credentials) return;

    try {
      // Step 3: Verify admin credentials
      const verifyRes = await axios.post(`${Api}admin/login.php`, {
        username: credentials.username,
        password: credentials.password,
      });

      if (!verifyRes.data || !verifyRes.data.token) {
        Swal.fire("Error!", "Invalid admin credentials!", "error");
        return;
      }

      // Step 4: Proceed to delete the product
      await axios.get(`${Api}product/delete.php?id=${id}`);

      fetchProducts();

      Swal.fire(
        "Deleted!",
        "Product has been deleted successfully.",
        "success"
      );
    } catch (err) {
      console.error("Delete error", err);
      Swal.fire("Error!", "Failed to verify admin or delete product.", "error");
    }
  };

  const handleDeleteCategory = async (category) => {
    // Step 1: Ask for confirmation
    const confirmResult = await Swal.fire({
      title: `Delete "${category}"?`,
      text: "This will delete all products in this category. This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, continue",
    });

    if (!confirmResult.isConfirmed) return;

    // Step 2: Ask for admin credentials
    const { value: credentials } = await Swal.fire({
      title: "Admin Verification Required",
      html: `
      <input type="text" id="swal-username" class="swal2-input" placeholder="Admin Username" />
      <input type="password" id="swal-password" class="swal2-input" placeholder="Admin Password" />
    `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Verify & Delete",
      preConfirm: () => {
        const username = document.getElementById("swal-username").value;
        const password = document.getElementById("swal-password").value;

        if (!username || !password) {
          Swal.showValidationMessage("Please enter both username and password");
          return false;
        }
        return { username, password };
      },
    });

    if (!credentials) return;

    try {
      // Step 3: Verify admin credentials via API
      const verifyRes = await axios.post(`${Api}admin/login.php`, {
        username: credentials.username,
        password: credentials.password,
      });

      if (!verifyRes.data || !verifyRes.data.token) {
        Swal.fire("Error!", "Invalid admin credentials!", "error");
        return;
      }

      // Step 4: Proceed to delete category
      await axios.get(
        `${Api}product/delete_category.php?category=${encodeURIComponent(
          category
        )}`
      );

      // ✅ Reset view and refresh product list
      setSelectedCategory("All Products");
      fetchProducts();

      Swal.fire(
        "Deleted!",
        `All products in "${category}" have been deleted successfully.`,
        "success"
      );
    } catch (err) {
      console.error("Category delete error", err);
      Swal.fire(
        "Error!",
        "Failed to verify admin or delete category.",
        "error"
      );
    }
  };

  const handleEdit = (item) => {
    setForm(item);
    setEditId(item.id);
  };

  const uniqueCategories = [
    "All Products",
    ...new Set(products.map((p) => p.category)),
  ];

  const filtered =
    selectedCategory === "All Products"
      ? products
      : products.filter((p) => p.category === selectedCategory);

  return (
    <div className="container-fluid mt-4">
      {/* Form */}
      <div className="row g-3 mb-3">
        <div className="col-md-2">
          <input
            name="category"
            value={form.category}
            onChange={handleChange}
            className="form-control"
            placeholder="Category"
          />
        </div>
        <div className="col-md-2">
          <input
            name="product"
            value={form.product}
            onChange={handleChange}
            className="form-control"
            placeholder="Product"
          />
        </div>

        <div className="col-md-2">
          <input
            name="barcode"
            value={form.barcode}
            onChange={handleChange}
            className="form-control"
            placeholder="Barcode"
          />
        </div>

        <div className="col-md-2">
          <input
            name="stock"
            type="number"
            min="1"
            value={form.stock}
            onChange={handleChange}
            className="form-control"
            placeholder="Stock"
          />
        </div>

        <div className="col-md-2">
          <input
            name="price"
            type="number"
            min="1"
            value={form.price}
            onChange={handleChange}
            className="form-control"
            placeholder="Price ₹"
          />
        </div>

        <div className="col-md-2">
          <input
            name="retail_price"
            type="number"
            min="1"
            value={form.retail_price}
            onChange={handleChange}
            className="form-control"
            placeholder="Retail ₹"
          />
        </div>

        <div className="col-md-4">
          <input
            name="image"
            type="file"
            accept="image/*"
            onChange={handleImageChange}
            className="form-control"
          />
        </div>
        {form.image && (
          <div className="mt-2">
            <img
              src={form.image}
              alt="Preview"
              style={{ width: "100px", height: "100px", objectFit: "cover" }}
            />
          </div>
        )}

        <div className="col-md-2">
          <button
            className={`btn ${editId ? "btn-warning" : "btn-success"} w-100`}
            onClick={handleSubmit}
          >
            {editId ? "Update" : "Add"}
          </button>
        </div>
      </div>

      {/* Category Filter */}
      <div className="row">
        <div className="col-md-2">
          <div className="list-group shadow-sm">
            {uniqueCategories.map((cat) => (
              <div
                key={cat}
                className={`d-flex justify-content-between align-items-center list-group-item list-group-item-action fw-semibold ${
                  selectedCategory === cat ? "bg-success text-white" : ""
                }`}
                style={{ cursor: "pointer" }}
                onClick={() => setSelectedCategory(cat)} // ✅ Click anywhere on row
              >
                <span>{cat}</span>
                {cat !== "All Products" && (
                  <Trash2
                    size={18}
                    className="text-danger"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.stopPropagation(); // ✅ prevents triggering row click
                      handleDeleteCategory(cat);
                    }}
                  />
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Product Cards */}
        {/* Product Cards */}
        <div className="col-md-10">
          {/* Header with Category name + Add button */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="fw-bold mb-0">{selectedCategory} Products</h5>
            {selectedCategory !== "All Products" && (
              <button
                className="btn btn-sm btn-primary"
                onClick={() =>
                  setForm((prev) => ({ ...prev, category: selectedCategory }))
                }
              >
                + Add Product
              </button>
            )}
          </div>

          <div className="row g-3 mt-2">
            {filtered.map((item) => (
              <div className="col-md-3" key={item.id}>
                <div className="card shadow-sm h-100">
                  {item.image && (
                    <img
                      src={item.image}
                      className="card-img-top"
                      alt={item.product}
                      style={{ height: "150px", objectFit: "cover" }}
                    />
                  )}
                  <div className="card-body">
                    <h6 className="fw-bold">{item.product}</h6>
                    <p>Wholesale: ₹{item.price}</p>
                    <p>Retail: ₹{item.retail_price}</p> {/* ✅ NEW LINE */}
                    <p className="text-muted">Barcode: {item.barcode}</p>
                    <p className="text-muted">Stock: {item.stock}</p>
                    <button
                      className="btn btn-sm btn-outline-warning me-2"
                      onClick={() => handleEdit(item)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => handleDelete(item.id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            ))}
            {filtered.length === 0 && (
              <div className="col-12 text-center text-muted py-4">
                No products found.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
